<template>
  <div class="article-frame sup-page-frame">
    <div class="article-box sup-page-box">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_register_banner.png')" alt="登録方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <h1 class="sup-page-title">
          登録方法
        </h1>

        <div class="sup-steps-box">
          <!-- ステップ 1 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <p class="sup-step-desc">
              ホーム画面の「新規登録」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_register_1.png')" alt="ステップ1">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 2 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <p class="sup-step-desc">
              必要情報を入力し、「アカウントを作成」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_register_2.png')" alt="ステップ2">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 3 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <p class="sup-step-desc">
              入力したメールアドレスに届いた「認証コード」を確認る
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_register_3.png')" alt="ステップ3">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 4 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 4
            </p>
            <p class="sup-step-desc">
              受信した認証コードを入力し、「認証」をタップ
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_register_4.png')" alt="ステップ4">
            </div>
          </div>

          <hr class="sup-step-divider">

          <!-- ステップ 5 -->
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 5
            </p>
            <p class="sup-step-desc">
              個人情報の入力を完了すると登録完了とうとう
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_register_5.png')" alt="ステップ5">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'

export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      isActive: true
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'register',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  created() {
  },
  methods: {

  }
}
</script>
